<template>
  <a-config-provider :theme="{ token: { colorPrimary: '#1890FF' } }">
    <router-view />
  </a-config-provider>
</template>

<script>
export default {
  name: 'App'
}
</script>
